import {FC, useEffect, useRef} from 'react'
import {useNavigate, useSearchParams} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import toast from 'react-hot-toast'
import {useUser} from '../../contexts/UserContext'
import {useAuth} from '../../hooks/useAuth'
import SplashScreen from '../splash/SplashScreen'

const OAuth2Callback: FC = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const {t} = useTranslation(['auth', 'common'])
  const {user} = useUser()
  const {isAuthenticated} = useAuth()
  const hasProcessed = useRef(false)

  useEffect(() => {
    if (hasProcessed.current) {
      return
    }
    hasProcessed.current = true

    const error = searchParams.get('error')
    const message = searchParams.get('message')
    const errorCode = searchParams.get('error_code')

    if (error || message) {
      if (errorCode === 'invalid_request' || message?.includes('400')) {
        const retryCount = parseInt(sessionStorage.getItem('oauth_retry_count') || '0')

        if (retryCount < 1) {
          toast(t('auth:retrying_login') || 'Retrying login...', {icon: 'ℹ️'})
          navigate('/login?oauth_error=true&error_code=invalid_request', {replace: true})
          return
        }
      }

      toast.error(message || t('auth:oauth_login_failed'))
      navigate('/login', {replace: true})
      return
    }

    if (!isAuthenticated || !user) {
      toast.error(t('auth:auth_successful_but_failed_load'))
      navigate('/login', {replace: true})
      return
    }

    if (user.profileComplete === false) {
      navigate('/profile/complete', {replace: true})
    } else {
      navigate('/dashboard', {replace: true})
    }
  }, [searchParams, navigate, t, user, isAuthenticated])

  return <SplashScreen/>
}

export default OAuth2Callback
